var React = require('react');

function PointsTriangle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M26.8926 114.207L36.7602 236.732L-109.165 109.509L26.8926 114.207Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M120.099 62.5327L36.6031 236.818L26.8011 114.448L120.099 62.5327Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M120.094 62.5312L26.8615 114.41L-109.17 109.506L120.094 62.5312Z","fill":"#5915C7","key":2})]);
}

PointsTriangle.defaultProps = {"width":"175","height":"269","viewBox":"0 0 175 269","fill":"none"};

module.exports = PointsTriangle;

PointsTriangle.default = PointsTriangle;
